<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style"; 
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import eppAPI from "@/services/standards/epp/eppAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/EPP/EppPagination";
import ScoreAPI from "@/services/standards/score/scoreAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist"
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
/**
 * Form elements component
 */
export default { 
  page: {
    title: "Entrega de elementos de protección personal EPP",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DontExist,
  },
  data() {
    
    return {
      title: "4.2.6 Entrega de elementos de protección personal EPP",
       items: [
       
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Entrega de elementos de protección personal EPP",
          active: true,
        },
      ],
       

      lista:[ ],
    //  loading: true,
    usersList: [],

      item: null,
      itemStatus: null, 

      itemData: null,

      epp: {
        
        start_date_epp: null,
        end_date_epp: null,
        file: null,
        employee_id: 1,
    
      },
     

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      
    

     
    };
  }, 
  methods: {

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {

          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              console.log(res);
              this.usersList = res
            })

        })
        .catch((error) => {
          console.log(error);
        });

    },

    getItemData() {
      ItemAPI.getItems(50)
        .then((response) => {
          console.log("Item: ", response);
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },



    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },
    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {

CompanyItemsAPI.getStatus(this.companyID, 50)
  .then(response => {
    this.item = response || null
    this.itemStatus = response.status ? response.status : null
    console.log(`This is the item ${this.item ? this.item.items_id : null}: `, this.item)
  })
  .catch(error => {
    console.log(error)
  })
},

    changeItemStatus(item, itemStatus) {

console.log(item, itemStatus)

if (item) {

  const itemChange = {
          items_id: item.items_id,
          status: itemStatus,
          operation: item.operation,
          puntation_absoluta: item.puntation_absoluta,
          puntation_relative: item.puntation_relative,
        }

  console.group('Data that will be updated')
  console.log('New item status: ', itemChange)
  console.log('CompanyID: ', this.companyID)
  console.groupEnd()

  CompanyItemsAPI.updateStatus(this.companyID, itemChange)
    .then(response => {
      console.log(response)

      if (
              response.message ===
                "item actualizado con exito, se ha sumado el valor del item , en la puntuacion" ||
              response.message === "item actualizado con exito"
            ) {
              Swal.fire({
                title: "¡Se ha actualizado el estado del ítem con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            } else {
              Swal.fire({
                title: "No se ha podido actualizar el estado del ítem",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }

    })
    .catch(error => {
      console.log(error)
    })

}

},
 
 /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
     getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then(response => {
          item = response || null
          itemStatus = response.status
          console.log(`This is the item ${item ? item.items_id : null}: `, item)
        })
        .catch(error => {
          console.log(error)
        })
    },

/**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
     sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },


     /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action 
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty
        
        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged
      
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

      /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page
   
    },

    
    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },
    
    async uploadFile() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);
    },

    async uploadDocument() {
      try {
        const url = `${this.epp.employee_id}/EPP/${this.file.name}`;
        const result = await uploadDocument(url, this.file);
        console.log(result);
        if (result) {
          this.epp.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
          console.log(this.epp.file)
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },
    getProtection() {
      eppAPI.getEpp(this.$route.params.id)
        .then((response) => {
          this.loading = false
          console.log('prueba', response);
          this.epp = {  

        start_date_epp: response.start_date_epp,
        end_date_epp: response.end_date_epp,
        file: response.file,
        employee_id: response.employee_id,
          };
        
          
        })
        .catch((error) => {
          console.log(error);
        });
    },
    save() {
     console.log("aqui la info ", this.epp);
     if (this.file)
           this.epp.file = `${process.env.VUE_APP_BUCKET}/${this.epp.employee_id}/EPP/${this.file.name}`;

     eppAPI.updateEpp( this.$route.params.id, {
          
        start_date_epp: this.epp.start_date_epp,
        end_date_epp: this.epp.end_date_epp,
        file: this.epp.file,
        employee_id: this.epp.employee_id,
          
        })
        .then((response) => {
           this.uploadDocument();
          Swal.fire({
                title: "¡Informacion actualizada con éxito!",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
          this.$router.go(-1);
          console.log(response);
        });
    },


  
    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItem() {
      CompanyItemsAPI.getStatus(this.companyID, 50)
        .then(response => {

          //this.exist = response.id ? true : false
          this.exist = response.id
          console.group('Item 50: ')
          console.log('This is the item 50: ', response)
          console.log('Is this item exist? ', this.exist)
          console.groupEnd()

        })
        .catch(error => {
          console.log(error)
        })
    },

     
  },

  mounted() {
    this.getItems()
    this.getItem()
    this.getProtection()
    this.getItemData();
    this.getUsers()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if=" !loading && classificationID <= 4 ">  
        <div class="card">
          <div class="card-body">
             <div class="row">
              <div class="col-md-6 col-sm-12">

<CheckModal>
  <p class="text-justify">
    Descargar el archivo con la matriz de IPEVR, realizar diligenciamiento de cada uno de los campos correspondientes, para poder determinar los controles que se deberán implementar. Es necesario que se cuente con la participación de todos los niveles de la organización en la identificación de estos peligros, se puede realizar por medio de capacitaciones, encuestas, inspecciones, entre otros.
  </p>
</CheckModal>
</div>
            

              
             
            </div>

        

            
            

            <form class="form-group" @submit.prevent="save">
              <div class="form-row pt-3">

              

                <b-form-group class="col-md-6" label="Fecha inicio vigencia matriz EPP" label-for="employee">
                  <b-form-input  type="date" id="code" v-model="epp.start_date_epp" placeholder=""></b-form-input>
                  </b-form-group>

           
                  <b-form-group class="col-md-6" label="Fecha fin vigencia matriz EPP" label-for="employee">
                    <b-form-input  type="date" id="name"  v-model="epp.end_date_epp" placeholder=""></b-form-input>
                  </b-form-group>
                
                  
                  
                  
                    
                   
              </div>

              <div class="form-row">
                <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                  <select  required class="form-control" v-model="epp.employee_id">
                    <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                      {{ item.full_name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
              
              <b-form-group class="col-md-6" label="Subir matriz EPP a entregar" label-for="hora">
                <b-form-file  required type="file" id="file" ref="file" name="file" browse-text="Buscar"
                :placeholder="epp.file ? getFile(epp.file) : `Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile">
                  </b-form-file>
              </b-form-group>
             
                </div>

              <div class="form-group text-right m-b-0">
                <button  type="submit" class="btn btn-primary">
                  Guardar
                </button>
                <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                  Cancelar
                </button>
              </div>

            
            </form>
          </div>
        </div>
      


      </div>

                  <div v-else-if=" !loading && classificationID > 3 " >
                    <DontExist />
                  </div>

                  <div v-else-if="!loading">
                    <DontExist />
                  </div>
                  <div v-else class="col-xl-12 text-center">
                    <div class="text-center">
                      <b-spinner variant="primary" label="Loading..."></b-spinner>
                    </div>
                  </div> 
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>